import type {CanvasChatMessage} from '@/pages/canvas/canvas-types';
import {chatTaskAnchorId,chatTaskShortcuts} from './chat-task-navigation';

export function ChatTaskNavigation({messages,isWorking}:{messages:CanvasChatMessage[];isWorking:boolean}){
  const visible=isWorking?chatTaskShortcuts(messages).filter(task=>task.status==='In progress'):[];
  if(!visible.length)return null;
  return <nav aria-label="Tasks in this chat" data-testid="chat-task-navigation" style={{display:'flex',alignItems:'stretch',gap:6,height:28,marginBottom:-4,padding:0,minWidth:0}}>
    {visible.length>0&&<div style={{display:'flex',flex:'1 1 auto',minWidth:0,gap:4,overflowX:'auto',scrollbarWidth:'none'}}>
      {visible.map(task=><button key={task.messageId} type="button"
        title={`${task.label} · ${task.taskType} · ${task.status}`}
        aria-label={`Jump to ${task.label}, ${task.taskType}, ${task.status}`}
        onClick={()=>{
          const target=document.getElementById(chatTaskAnchorId(task.messageId));
          if(!target)return;
          target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
          target.focus({preventScroll:true});
        }}
        style={{display:'inline-flex',alignItems:'center',gap:6,flex:'0 0 auto',maxWidth:220,minWidth:0,height:28,textAlign:'left',border:'1px solid #E5E2DC',borderBottom:0,borderRadius:'6px 6px 0 0',padding:'0 9px',background:'#F0EFEC',cursor:'pointer'}}>
        <span aria-hidden="true" style={{width:5,height:5,borderRadius:'50%',flexShrink:0,background:task.completed?'#7D8578':'#A9315B'}} />
        <span style={{display:'block',fontSize:11,fontWeight:600,color:'#292624',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{task.label}</span>
      </button>)}
    </div>}
  </nav>;
}
